module.exports = __webpack_public_path__ + "img/retrospect-30.96dc06b9.jpg";